


















































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { useConfirmDialog } from '@vueuse/core';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size } from '@front-app/components/constants';
import { useStatus } from '@front-app/hooks/useAsyncStatus';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ConfirmationModal from '@front-app/components/modals/ConfirmationModal.vue';
import TrModal from '@front-app/components/modals/TrModal.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import StandardErrorText from '@front-app/components/cards/state/StandardErrorText.vue';
import { STATUS } from '@front-app/constants/state';

export default defineComponent({
	components: {
		CtaButton,
		ConfirmationModal,
		LoaderState,
		StandardErrorText,
		TrModal,
	},
	props: {
		status: {
			type: String as PropType<STATUS>,
			required: true,
		},
	},
	setup(props) {
		const {
			isLoading,
			isError,
		} = useStatus(computed(() => props.status));
		const confirmDeclineModal = useConfirmDialog();
		return {
			isLoading,
			isError,
			confirmDeclineModal,
			ButtonPalettes,
			Size,
		};
	},
});
